import { ERentioFormField } from "../../components/components/Form";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { EField } from "./schema.createPayment.types";
import { customContactsSelector, customContactsValueSelector, getDefaultPayerPayeeValue, getNavigationTitle, getRelatedContract, getSubtitle, } from "./schema.createPayment.utils";
import { customGetContactsActions, customIsFetchingSelector, } from "./schema.createPayment.utils.fetchContacts";
export var getSchema = function (initialValues, extraData) {
    return function (defaultValues) {
        var _a;
        var contract = getRelatedContract(extraData, defaultValues);
        return {
            required: [EField.Payee],
            properties: (_a = {},
                _a[EField.Header5] = {
                    default: undefined,
                },
                _a[EField.Payee] = {
                    default: getDefaultPayerPayeeValue({
                        key: EField.Payee,
                        initialValues: initialValues,
                        defaultValues: defaultValues,
                        type: defaultValues[EField.TypeRecurring] ||
                            defaultValues[EField.TypeOnce],
                        contract: contract,
                    }),
                },
                _a),
            // @ts-ignore
            stepsToClearOnSubmitFromSummary: function (currentStepIndex) { return [
                currentStepIndex + 1,
            ]; },
        };
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return (_a = {
            "rentio:title": getLocalizedText("payments.create.payee.heading.summary"),
            "rentio:navigationTitle": getNavigationTitle(extraData),
            "rentio:summaryTitle": getLocalizedText("payments.create.payee.heading.summary")
        },
        _a[EField.Header5] = {
            "ui:field": ERentioFormField.SectionHeader,
            getTitle: function (formData) {
                return getLocalizedText("payments.create.payee.heading", {
                    type: formData.otherDescription ||
                        getLocalizedText("payment.payment_order.type.".concat(formData.typeRecurring || formData.typeOnce).toLowerCase()),
                });
            },
        },
        _a[EField.Payee] = {
            "ui:field": ERentioFormField.ContactSelectInlineV2,
            getTitle: function () { return getLocalizedText("payment.payment_order.payee.heading"); },
            selectContactFromListCtaTitle: getLocalizedText("payment.payment_order.payee.select_other.cta"),
            addCtaLabel: getLocalizedText("payment.payment_order.payee.other.label"),
            isMultiSelect: false,
            asOptionList: true,
            // Custom selectors & actions
            valueSelector: function (state, selectedAccountIds) {
                return customContactsValueSelector({
                    state: state,
                    propertyId: extraData.property.id,
                    selectedAccountIds: selectedAccountIds,
                });
            },
            customGetSubtitleSelector: function (state, formData, item) {
                return getSubtitle({
                    state: state,
                    contract: getRelatedContract(extraData, formData),
                    item: item,
                });
            },
            customExtraAccountsSelector: function (state, formData) {
                if (formData === void 0) { formData = {}; }
                return customContactsSelector({
                    formData: formData,
                    type: formData[EField.TypeRecurring] || formData[EField.TypeOnce],
                    payerType: "payee",
                    state: state,
                    contract: getRelatedContract(extraData, formData),
                });
            },
            customIsFetchingSelector: function (state) {
                return customIsFetchingSelector(state, extraData);
            },
            customGetContactsActions: customGetContactsActions(extraData),
        },
        _a);
};
